import type { ComponentProps } from "react";
import BaseActionButton from "./BaseActionButton";

type SkipButtonProps = Omit<
    ComponentProps<typeof BaseActionButton>,
    "iconType" | "testId" | "buttonType" | "variant" | "label" | "loadingText"
> & {
    label?: string;
    loadingText?: string;
};

const SkipButton = ({ label = "Skip", loadingText = "Skipping...", ...props }: SkipButtonProps) => {
    return (
        <BaseActionButton
            label={label}
            loadingText={loadingText}
            iconType="skip"
            testId="skip-button"
            buttonType="button"
            variant="secondary"
            {...props}
        />
    );
};

export default SkipButton;
